import Home1 from './Home/1.js'
import Home2 from './Home/2.js'
import Home3 from './Home/3.js'
import Home4 from './Home/4.js'
import Home5 from './Home/5.js'
import Home6 from './Home/6.js'
import Home7 from './Home/7.js'
import Home8 from './Home/8.js'

export default function Home() {
  return (
    <div>
        <Home1 />
        <Home2 />
        <Home3 />
        <Home4 /> 
        <Home5 />
        <Home6 />
        <Home7 />
        <Home8 />
    </div>
  )
}
